import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_242: DocMigration = {
  maxSchemaVersion: "0.0.242",
  description: "Rename columnPatterns to porchColumnPatterns",
  apply(json: any) {
    if (json.roomLayouts) {
      for (const layoutId in json.roomLayouts) {
        const roomLayout = json.roomLayouts[layoutId];
        if (roomLayout.columnPatterns) {
          roomLayout["porchColumnPatterns"] = [...roomLayout.columnPatterns];
          for (const columnPatternId in roomLayout.porchColumnPatterns) {
            const columnPatternData = roomLayout.porchColumnPatterns[columnPatternId];
            if (columnPatternData.columnPattern) {
              const porchColumnPattern = { ...columnPatternData.columnPattern };
              roomLayout.porchColumnPatterns[columnPatternId] = {
                ...columnPatternData,
                ["porchColumnPattern"]: { ...porchColumnPattern },
              };
              delete roomLayout.porchColumnPatterns[columnPatternId].columnPattern;
            }
          }
          delete roomLayout.columnPatterns;
        }
      }
    }
    return json;
  },
};

export default migration_0_0_242;
